module.exports = __webpack_public_path__ + "img/Our_work_8.00a01548.png";